import { render, staticRenderFns } from "./insCost.vue?vue&type=template&id=43b45ec3&"
import script from "./insCost.vue?vue&type=script&lang=js&"
export * from "./insCost.vue?vue&type=script&lang=js&"
import style0 from "./insCost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports